module.exports = __webpack_public_path__ + "static/media/IMG_8903.981ee984.JPG";